import type { Action } from "../actions.types";

/**
 * Check if user has an action of a specific type.
 */
export function hasAction(actions: Action[], slug: string): boolean {
  return actions.some((a) => a.action_type?.slug === slug);
}

